import { render } from "./AddPoints.vue?vue&type=template&id=b7eff124&scoped=true"
import script from "./AddPoints.vue?vue&type=script&lang=js"
export * from "./AddPoints.vue?vue&type=script&lang=js"

import "./AddPoints.vue?vue&type=style&index=0&id=b7eff124&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7eff124"]])

export default __exports__